import _ from 'lodash';

// @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'ReactionSummaryGQL'.
export function getUniqueUsers(reactionsSummary: ReactionSummaryGQL): any[] {
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'r' implicitly has an 'any' type.
  const users = _.flatten(reactionsSummary.reactions.map((r) => r.users));
  return _.unionBy(users, 'uuid');
}

export function userNamesReplacingYourNameWithYou(users: any[], userUuid: string): string[] {
  return users.map((u) => {
    return u.uuid === userUuid ? 'You' : u.name;
  });
}
